<template>

<main class="container">

  <div class="board">
    <div class="buttons" info-light fw-30>
      <sym-link class="button" to="samples-container">Containers</sym-link>
      <sym-link class="button" to="samples-card">Cards</sym-link>
      <sym-link class="button" to="samples-button">Buttons</sym-link>
      <sym-link class="button" to="samples-collapse">Collapse</sym-link>
      <sym-link class="button" to="samples-alert">Alerts</sym-link>
      <sym-link class="button" to="samples-form">Form</sym-link>
      <sym-link class="button" to="samples-device-info">Device Info</sym-link>
      <sym-link class="button" to="samples-video">Videos</sym-link>
      <sym-link class="button" to="movie-search">Movies</sym-link>
    </div>
  </div>

  <!-- <sym-progress-bar class="striped sm-2" :value="40">
  </sym-progress-bar> -->

  <!-- <div class="board">
    <sym-link to="rpt0010" class="badge warning sm-3 curved-3">25</sym-link>
    <span class="badge info curved-3 bold">52</span>
    <button class="info-light"><span class="mr-2">Submit</span><span class="badge info curved-3 boldXX sm-3">52</span></button>
  </div> -->

  <!-- <div class="d-flex justify-center">
    <sym-dropdown class="dropdown">
      <button type="button" class="drop-toggle dark" slot="toggle">Dropdown</button>
      <div class="dropbox align-right shadow">
        <sym-link class="dropitem" to="rpt0010"></sym-link>
        <hr>
        <sym-link class="dropitem" to="sts1010"></sym-link>
        <sym-link class="dropitem" to="sts1020"></sym-link>
        <hr>
        <sym-link class="dropitem" to="sts1030"></sym-link>
        <sym-link class="dropitem" to="sts1040"></sym-link>
        <button class="dropitem" to="sts1040">WWW</button>
        <button class="dropitem" to="sts1040">XXX</button>
      </div>
    </sym-dropdown>
  </div> -->

</main>

</template>

<script>

import PageBase from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'samples'
};

</script>
